import SectionLink from "@components/LeftMenu/SectionLink";
import SectionTitle from "@components/LeftMenu/SectionTitle";
import {GRATUITO} from "@constants/planos";
import {routeCodes} from "@constants/routes";
import classNames from "classnames";
import React from "react";
import {useLocation} from "react-router-dom";

function MenuMinhaContaPlanos({currentPlano, hasSubscriptionInMobileApp, isBlackFriday}) {
  const location = useLocation();
  const isActive = (value) => {
    if (location.pathname === value) return true;
    return false;
  };

  return (
    <React.Fragment>
      <h4
        className={`navigation-section-title-sm purple-text bold small-only ${
          isBlackFriday && location.pathname === "/planos/inicio" ? "white-text" : null
        }`}
      >
        Planos & Assinaturas
      </h4>
      <SectionTitle
        title="Planos & Assinaturas"
        className={`navigation-section-title ${
          isBlackFriday && location.pathname === "/planos/inicio"
            ? "white-text"
            : "purple-text"
        } bold uppercase large-only mt-1`}
      />
      <SectionLink
        title="Planos"
        link={routeCodes.PLANOS_PRINCIPAL}
        className={classNames({
          "navigation-section-link": true,
          "navigation-section-link-black-friday":
            isBlackFriday && location.pathname === "/planos/inicio" ? true : false,
          bold: true,
          "mt-5": true,
          active: isActive(routeCodes.PLANOS_PRINCIPAL),
        })}
      />
      {currentPlano?.id !== GRATUITO.id && !hasSubscriptionInMobileApp ? (
        <React.Fragment>
          <SectionLink
            title="Pagamentos"
            link={routeCodes.PLANOS_PAGAMENTOS}
            className={classNames({
              "navigation-section-link": true,
              "navigation-section-link-black-friday":
                isBlackFriday && location.pathname === "/planos/inicio" ? true : false,
              bold: true,
              "my-3": true,
              active: isActive(routeCodes.PLANOS_PAGAMENTOS),
            })}
          />
          {/* <SectionLink
            title="Indique e ganhe"
            link={routeCodes.INDIQUE_E_GANHE}
            className={classNames({
              "navigation-section-link": true,
              "navigation-section-link-black-friday":
                isBlackFriday && location.pathname === "/planos/inicio" ? true : false,
              bold: true,
              "my-3": true,
              active: isActive(routeCodes.INDIQUE_E_GANHE),
            })}
          /> */}
        </React.Fragment>
      ) : null}
    </React.Fragment>
  );
}

export default MenuMinhaContaPlanos;
